import * as React from 'react'
import { SelfServiceContainerProps } from './types'
import './index.scss'
import { SelfServiceHeader } from '../components/SelfServiceHeader'
import { SegmentContext } from '../hooks/SegmentContext'

export const SelfServiceContainer: React.FC<SelfServiceContainerProps> = ({ children, title, whatsappIsOff, generalModule }) => {
  const { segmentTrack } = React.useContext(SegmentContext)
  const [showContent, setShowContent] = React.useState<boolean>(false)
  const [containerIsOpen, setContainerIsOpen] = React.useState<boolean>(false)
  const safeTitle = title ?? 'Como podemos ajudar?'

  const containerRef = React.useRef<HTMLDivElement>(null)
  const containerMobileRef = React.useRef<HTMLDivElement>(null)

  function handleOpenContainer(whatsappClicked: boolean) {
    segmentTrack('Widget Clicked', {
      widget: !containerIsOpen,
      alt_text: whatsappClicked ? 'ícone-whatsapp' : 'ajuda-alt',
    })
    setContainerIsOpen(!containerIsOpen)
  }

  React.useEffect(() => {
    if (containerIsOpen) {
      document.documentElement.style.overflow = 'hidden'
    } else {
      document.documentElement.style.overflow = 'auto'
    }
  }, [containerIsOpen])

  function handleClickOutside(event: MouseEvent | TouchEvent) {
    const containerDesktop = containerRef.current
    let containerDesktopClicked = false
    if (containerDesktop) containerDesktopClicked = containerDesktop.contains(event.target as Node)

    const containerMobile = containerMobileRef.current
    let containerMobileClicked = false
    if (containerMobile) containerMobileClicked = containerMobile.contains(event.target as Node)

    if (!containerDesktopClicked && !containerMobileClicked) {
      setContainerIsOpen(false)
    }
  }

  React.useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside)
    document.addEventListener('touchstart', handleClickOutside)

    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
      document.removeEventListener('touchstart', handleClickOutside)
    }
  }, [])

  return (
    <>
      {containerIsOpen && <div id="selfServiceOverlay"></div>}

      <div
        ref={containerRef}
        id="selfServiceContainer"
        data-testid="selfServiceContainer"
        className={`service-container ${containerIsOpen ? 'open' : ''}  ${whatsappIsOff ? 'whatsapp-off' : ''}`}>
        <SelfServiceHeader showContent={setShowContent} openContainer={handleOpenContainer} isOpen={containerIsOpen} isMobile={false} />
        <div className={`service-main-container ${showContent ? 'open' : ''} ${generalModule ? 'general' : ''}`}>{children}</div>
      </div>

      <div
        ref={containerMobileRef}
        data-testid="selfServiceContainerMobile"
        id="selfServiceContainerMobile"
        className={`service-container-mobile ${containerIsOpen ? 'open' : ''}  ${whatsappIsOff ? 'whatsapp-off' : ''}`}>
        <SelfServiceHeader openedTitle={safeTitle} showContent={setShowContent} openContainer={handleOpenContainer} isOpen={containerIsOpen} isMobile />
        <div className={`service-main-container ${showContent ? 'open' : ''} ${generalModule ? 'general' : ''}`}>{children}</div>
      </div>
    </>
  )
}
